import React, { useEffect, useRef, useState } from "react";
import IndonesiaFlag from "../../../assets/images/Icons/icons/indonesia_flag.png";
import EnglandFlag from "../../../assets/images/Icons/icons/england_flag.png";
import GlobeIcon from "../../../assets/images/Icons/icons/lang_icon.png";
import { FaCaretDown, FaSyncAlt } from "react-icons/fa";
import InfoPopup from "./InfoPopup";
import DreamBookPopup from "./DreamBookPopup";
import StatementPopup from "./StatementPopup";
import NotificationPopup from "./NotificationPopup";
import { TOKEN_KEY } from "../../../helpers/url_helper";
import { useDispatch, useSelector } from "react-redux";
import { IoIosClose } from "react-icons/io";
import { IoSettings } from "react-icons/io5";
import SettingIcon from "../../../assets/images/Icons/Setting_dark.svg";
import SettingIconLight from "../../../assets/images/Icons/Setting_light.svg";
import ResultImg from "../../../assets/images/Icons/resulticon.svg";
import ResultDark from "../../../assets/images/Icons/resultdark.svg";
import DreamBook from "../../../assets/images/Icons/dreambook.svg";
import DreamBookLight from "../../../assets/images/Icons/dreambook-light.svg";
import { MdKeyboardArrowRight } from "react-icons/md";
import { TbBulb } from "react-icons/tb";
import TutorialDark from "../../../assets/images/Icons/Tutorial_dark.svg";
import TutorialLight from "../../../assets/images/Icons/Tutorial_light.svg";
import PromotionLight from "../../../assets/images/Icons/Promotion_light.svg";
import PromotionDark from "../../../assets/images/Icons/Promotion_dark.svg";
import cardgameTopLight from "../../../assets/images/Icons/cardgameTopLight.svg";
import cardgameTopDark from "../../../assets/images/Icons/cardgameTopDark.svg";
import dingdongTopLight from "../../../assets/images/Icons/dingdongTopLight.svg";
import dingdongTopDark from "../../../assets/images/Icons/dingdongTopDark.svg";
import arcadeTopLight from "../../../assets/images/Icons/arcadeTopLight.svg";
import arcadeTopDark from "../../../assets/images/Icons/arcadeTopDark.svg";


import PromoIcon from "../../../assets/images/Icons/icons/promo.svg";
import NewIcon from "../../../assets/images/Icons/icons/new.svg";
import HotTagIcon from "../../../assets/images/Icons/icons/hot.svg";

import {
  handelLogout,
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../helpers/global_helper";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { withTranslation } from "react-i18next";
import { formatPrice } from "../../NumberFormat";
import { getUserBalance, getUserProfile, setClickCount, setCommonConfig, setCurrentStep, setIsSettingCoachMark } from "../../../redux/actions";
import InnerPopup from "../../Popups/InnerPopup";
import UseBodyScrollLock from "../../Popups/UseBodyScrollLock";
import { BsTrophy, BsInfoCircle } from "react-icons/bs";
import { IoNotificationsOutline } from "react-icons/io5";
import { TfiNotepad } from "react-icons/tfi";
import { FiLogOut } from "react-icons/fi";
import { IoSunnyOutline } from "react-icons/io5";
import { FaRegMoon } from "react-icons/fa";
import LanguageItemMobile from "./LanguageItemMobile";
import CloseTimeAndResult from "../CloseTimeAndResult";
import CoachMarkPopup from "../../Popups/CoachMarkPopup";
import DummyCoachMark from "../../Popups/DummyCoachMark";


const langList = {
  en: {
    label: "English",
    short_label: "Eng",
  },
  id: {
    label: "Indonesian",
    short_label: "Ind",
  },
};

const HeaderRightMenu = (props) => {
  const darkModeRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isLangpopup, setIslangpopup] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    langList[localStorage.getItem("I18N_LANGUAGE") || "en"]["short_label"]
  );
  const [popupComponent, setPopupComponent] = useState(null);
  const [activeIcon, setActiveIcon] = useState(null);
  const device = useSelector((state) => state.CommonConfig.device_type);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastClickTime, setLastClickTime] = useState(0);
  const user_profile = useSelector((state) => state.UserProfile);
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const [isInitialFetchComplete, setIsInitialFetchComplete] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const depositUrl = sessionStorage.getItem("depositUrl");

  const helpRunFunction = async () => {
    const result = await dispatch(getUserBalance());
    if (result) {
      setIsInitialFetchComplete(true);
    }
  };

  const [labelMap, setLabelMap] = useState([]);
  useEffect(() => {
    console.log("user_profile.button_label_lobby", user_profile.button_label_lobby);
    if (user_profile.button_label_lobby) {
      const labelMap = Object.fromEntries(
        user_profile.button_label_lobby.split(";").map(pair => {
          const [key, values] = pair.split(":");
          return [key, values ? values.split(",") : []];
        })
      );
      setLabelMap(labelMap);
      console.log(labelMap);
    }
  }, [user_profile]);


  // ======= Skip currentStep on mobile landscape mode ======

  useEffect(() => {
    const handleOrientationChange = () => {
      const isLandscapeMobile =
        window.matchMedia("(max-width: 932px) and (max-height: 430px)").matches &&
        window.matchMedia("(orientation: landscape)").matches;

      if (isLandscapeMobile && currentStep === 8) {
        dispatch(setCurrentStep(9)); // Skip to the next step using Redux action
        dispatch(setClickCount(9));
      }
    };

    // Add event listener for orientation changes
    window.addEventListener("resize", handleOrientationChange);
    handleOrientationChange(); // Initial check

    // Cleanup listener
    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, [currentStep]);

  // ======= Skip currentStep on mobile landscape mode ======


  useEffect(() => {
    if (
      (device === "Mobile" || device === "Tablet") &&
      (currentStep === 9 || currentStep === 8 || currentStep === 10)
    ) {
      if (darkModeRef.current) {
        darkModeRef.current.scrollTop = 0; // Moves to the top of the element
      }
    }
  }, [currentStep, device]);

  useEffect(() => {
    helpRunFunction();
    let interval;
    if (isInitialFetchComplete) {
      interval = setInterval(() => {
        helpRunFunction();
      }, 120000);
    }

    return () => clearInterval(interval);
  }, [isInitialFetchComplete]);

  const handleLanguageChange = (lang, e) => {
    e.preventDefault();
    setSelectedLanguage(langList[lang]["short_label"]);
    setIslangpopup(false);
    let reqData = { lang: lang };
    makeAjax(
      url.PLAYER_API.updateUserLanguage,
      reqData,
      url.PLAYER_MS_EXT
    ).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      localStorage.setItem("I18N_LANGUAGE", lang);
      i18next.changeLanguage(lang);
    });
  };

  const handlePopupOpen = (component, iconName) => {
    setPopupComponent(component);
    setActiveIcon(iconName);
  };

  const handleClosePopup = () => {
    setPopupComponent(null);
    setActiveIcon(null);
  };

  const handleLogout = () => {
    makeAjax(url.PLAYER_API.logout, {}, url.PLAYER_MS_EXT).then((response) => {
      if (response.status === respStatus["SUCCESS"]) {
        showMessage(response);
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem("partner_token");

      }
    });
  };
  UseBodyScrollLock(isLangpopup);
  useEffect(() => { }, [device]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  UseBodyScrollLock(isOpen);

  useEffect(() => {
    if (window.location.pathname === "/result" && activeIcon == null) {
      setActiveIcon("result");
    }
    if (window.location.pathname === "/" && activeIcon === "result") {
      setActiveIcon(null);
    }
  }, [activeIcon, window.location.pathname]);

  const LanguageItem = () => (
    <div
      className={`menu-item ${activeIcon === "lanuage" && isLangpopup ? "iconactive" : ""
        }`}
      onClick={() => {
        setActiveIcon("lanuage");
        setIslangpopup(!isLangpopup);
      }}
    >
      <div className="dropdown">
        <button className={`dropbtn ${isLangpopup ? "langActive" : ""}`}>
          {selectedLanguage}
          <FaCaretDown />
        </button>

        <div className="dropdown-content">
          <div className="lang_close_icon">
            <IoIosClose onClick={() => setIslangpopup(false)} />
            {/* <img src={CloseIcon} alt=""  /> */}
          </div>
          <p>
            <img src={GlobeIcon} alt="" /> {props.t("language")}
          </p>
          {Object.keys(langList).map((key) => (
            <>
              {selectedLanguage !== langList[key].short_label && (
                <a
                  href=""
                  key={key}
                  onClick={(e) => handleLanguageChange(key, e)}
                >
                  <img
                    src={key === "id" ? IndonesiaFlag : EnglandFlag}
                    alt=""
                  />{" "}
                  {langList[key].label}
                </a>
              )}
            </>
          ))}
        </div>
        {isLangpopup && <div className="dropdown-overlay"></div>}
      </div>
      <h5>{props.t("language")}</h5>
    </div>
  );

  const handleRefreshClick = () => {
    setIsRefreshing(true);
    localStorage.setItem("refBtnVal", 1);
    const currentTime = new Date().getTime();
    const newClickTime = (currentTime - lastClickTime) / 1000;
    if (newClickTime < 8) {
      const remainingTime = Math.ceil(8 - newClickTime);
      setIsRefreshing(false);
      let msgName = props.t("try_again_after_8_second");
      const myArray = msgName.split("8");
      showMessage(myArray[0] + remainingTime + myArray[1], "error", "Message");
    } else {
      dispatch(getUserBalance());
      setLastClickTime(currentTime);
    }
    setTimeout(() => {
      localStorage.setItem("refBtnVal", 0);
      setIsRefreshing(false);
    }, 1000);
  };

  const handleShowCoachMark = () => {

    // makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameId, "gameType": "4d3d2d" }).then((response) => {
    //   if (response.status !== respStatus["SUCCESS"]) {
    //     showMessage(response);
    //     return;
    //   }
    //   const marketStatus = response.data.marketStatus
    //   if (marketStatus == "1") {
    //     navigate("/")
    //     dispatch(setCommonConfig({ key: "app_type", value: "desktop" }));
    //     dispatch(setIsSettingCoachMark(true));
    //     dispatch(setCurrentStep(0));
    //     setShowDropdown(false);
    //     closeMenu();
    //     return;
    //   }
    // })

    navigate("/")
    dispatch(setCommonConfig({ key: "app_type", value: "desktop" }));
    dispatch(setIsSettingCoachMark(true));
    dispatch(setCurrentStep(0));
    setShowDropdown(false);
    closeMenu();
    return;
  }

  const redirectLobby = (lobbyValue) => {
    let gameType = '';
    if (lobbyValue == 'cardgame') {
      gameType = 3;
    } else if (lobbyValue == 'dingdong') {
      gameType = 2;
    } else if (lobbyValue == 'arcade') {
      gameType = 7;
    }
    console.log(`You clicked : ${lobbyValue}`);
    makeAjax(url.PLAYER_API.redirectLobby, { "gameType": gameType, "depositUrl": depositUrl }, url.PLAYER_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      handleLogout();
      localStorage.clear();
      window.location.href = response.data.link;
    })
  }


  let showValue = isOpen;

  if (device == 'Mobile' && (currentStep > 7 && currentStep < 12) && isOpen === false) {
    // let show
    showValue = currentStep == 11 ? false : true;
  }

  // const isTablet = window.innerWidth >= 540 && window.innerWidth <= 1024;
  // style={{
  //   overflow: isTablet &&   currentStep === 8 || currentStep === 9 || currentStep === 10 ? 'visible' : 'scroll',
  // }}

  const HamburgerIcon = () => (
    <div className="hamburg-child"
    >
      <input type="checkbox" checked={showValue} onChange={toggleMenu} />
      <span></span>
      <span></span>
      <span></span>
      <div className="hambergerOverlay" onClick={closeMenu}></div>
      <ul ref={darkModeRef} id="menu" style={{
        overflow:
          (currentStep === 8 || currentStep === 9 || currentStep === 10) &&
            window.innerWidth >= 140 &&
            window.innerWidth <= 1024
            ? "visible"
            : "auto",
      }}>
        <li>
          <div className="user_details">
            <p>
              {props.t("user")} : <span>{user_profile.nickname}</span>
            </p>
            <p>
              {props.t("balance")} :{" "}
              <span>
                {user_profile.curr} {formatPrice(user_balance.coin)}
              </span>{" "}
              &nbsp;
              <span className="refresh-icon">
                <FaSyncAlt
                  className={isRefreshing ? "refreshing" : ""}
                  onClick={handleRefreshClick}
                />
              </span>
            </p>
          </div>
        </li>

        <li>
          <Link to={"/notification"} onClick={closeMenu} rel="noopener noreferrer nofollow">
            <div className="menu_icon">
              <IoNotificationsOutline className="header-icon" />
            </div>
            <p>{props.t("notify")}</p>
            <div className="notify_count">{user_balance.countNotif}</div>
          </Link>
        </li>

        {/* <li className={`result-menu custom-tooltip-wrapper ${currentStep === 9 ? "highlighted" : ""}`}> */}
        <li className={`result-menu custom-tooltip-wrapper ${currentStep === 9 ? "highlighted" : ""}`} ref={darkModeRef}>

          <Link to={"/result"} onClick={closeMenu} rel="noopener noreferrer nofollow">
            <div className="menu_icon">
              {/* <BsTrophy className="header-icon" /> */}
              {theme === 0 ? (
                <img src={ResultImg} className="header-icon result-icon" alt="Trophy" />
              ) : (
                <img src={ResultDark} className="header-icon result-icon" alt="Trophy" />
              )}
            </div>
            <p>{props.t("result")}</p>
          </Link>
          {currentStep === 9 && <CoachMarkPopup />}
        </li>
        {currentStep === 9 && <div className="custom-overlay"></div>}
        <li className={`info-menu custom-tooltip-wrapper ${currentStep === 10 ? "highlighted" : ""}`}>
          <Link to={"/information"} onClick={closeMenu} rel="noopener noreferrer nofollow">
            <div className="menu_icon">
              <BsInfoCircle className="header-icon" />
            </div>
            <p>{props.t("information")}</p>
          </Link>
          {currentStep === 10 && <CoachMarkPopup />}
        </li>
        {currentStep === 10 && <div className="custom-overlay"></div>}
        {/* <li>
          <Link to={"/notification"} onClick={closeMenu}>
            <div className="menu_icon">
              <IoNotificationsOutline className="header-icon" />
            </div>
            <p>{props.t("notify")}</p>
            <div className="notify_count">{user_balance.countNotif}</div>
          </Link>
        </li> */}
        {/* <li>
          <Link to={"/statement"} onClick={closeMenu}>
            <div className="menu_icon">
              <TfiNotepad className="header-icon" />
            </div>
            <p>{props.t("statement")}</p>
          </Link>
        </li>
        */}
        <li>
          <Link to={"/dreambook"} onClick={closeMenu}>
            <div className="menu_icon">
              <img src={theme === 0 ? DreamBookLight : DreamBook} className="header-icon  dream-img" />
            </div>
            <p>{props.t("dream_book")}</p>
          </Link>
        </li>

        <li>
          <div onClick={handleShowCoachMark} className="tutorial-btn " ref={darkModeRef}>
            {theme === 0 ? (
              <img src={TutorialLight} className="header-icon result-icon" alt="Trophy" />
            ) : (
              <img src={TutorialDark} className="header-icon result-icon" alt="Trophy" />
            )}
            <h5 className="tuto-label">{props.t("Tutorial")}</h5>
          </div>
        </li>

        <li>
          <div className="promotion-btn" ref={darkModeRef} onClick={handleBackClick}>
            {theme === 0 ? (
              <img src={PromotionLight} className="header-icon promotion-icon" alt="promotion" />
            ) : (
              <img src={PromotionDark} className="header-icon promotion-icon" alt="promotion" />
            )}
            <h5 className="promo-label">{props.t("Promotion")}</h5>
          </div>
        </li>

        <li
          className={`setting-menu custom-tooltip-wrapper  ${currentStep === 8 ? "highlighted" : ""}`}
        >
          <div className="toggle-link" onClick={toggleTheme}>
            <div className="theme-toggle-container">
              <button
                className={`theme-toggle switch ${theme === 0 ? 'light' : 'dark'}`}
                onClick={(e) => {
                  const newTheme = theme === 0 ? 1 : 0;
                  setTheme(newTheme);
                  e.stopPropagation(); // Prevent event bubbling to the Link
                  toggleTheme();
                }}
                aria-label="Toggle theme"
              >
                <span className="slider">
                  <div
                    className={`icon sun-icon ${theme === 0 ? "active" : ""
                      }`}
                  >
                    <IoSunnyOutline className="header-icon" />
                  </div>
                  <div
                    className={`icon moon-icon ${theme === 1 ? "active" : ""
                      }`}
                  >
                    <FaRegMoon className="header-icon" />
                  </div>
                </span>
              </button>
              <p className="theme-label">
                {theme === 0 ? "Light" : "Dark"}
              </p>
              {/* {currentStep === 8 && <CoachMarkPopup />} */}
              {currentStep === 8 && !window.matchMedia("(max-width: 932px) and (max-height: 430px) and (orientation: landscape)").matches && (
                <CoachMarkPopup />
              )}
            </div>
          </div>
        </li>
        {currentStep === 8 && <div className="custom-overlay"></div>}

        <li>
          <div className="toggle-link">
            <LanguageItemMobile />
          </div>
        </li>

        {(user_profile.CGGameCount > 0 ?
          <li className={`info-menu custom-tooltip-wrapper`}>
            <Link onClick={() => { closeMenu(); redirectLobby("cardgame") }} rel="noopener noreferrer nofollow">
              <div className="menu_icon">
                {theme === 0 ? (
                  <img src={cardgameTopLight} className="header-icon promotion-icon" alt="Cardgame" />
                ) : (
                  <img src={cardgameTopDark} className="header-icon" alt="Cardgame" />
                )}
              </div>
              <p>{props.t("Card Games")}</p>
              {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("promo")) || labelMap.cardgames.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
              {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("new")) || labelMap.cardgames.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
              {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("hot")) || labelMap.cardgames.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}
            </Link>

          </li>
          : '')}

        {
          (user_profile.DDGameCount > 0 ?
            <li className={`info-menu custom-tooltip-wrapper`}>
              <Link onClick={() => { closeMenu(); redirectLobby("dingdong") }} rel="noopener noreferrer nofollow">
                <div className="menu_icon">
                  {theme === 0 ? (
                    <img src={dingdongTopLight} className="header-icon promotion-icon" alt="Dingdong" />
                  ) : (
                    <img src={dingdongTopDark} className="header-icon" alt="Dingdong" />
                  )}
                </div>
                <p>{props.t("Dingdong")}</p>
                {(labelMap.dingdong && ((labelMap.dingdong.includes("blink") && labelMap.dingdong.includes("promo")) || labelMap.dingdong.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
                {(labelMap.dingdong && ((labelMap.dingdong.includes("blink") && labelMap.dingdong.includes("new")) || labelMap.dingdong.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
                {(labelMap.dingdong && ((labelMap.dingdong.includes("blink") && labelMap.dingdong.includes("hot")) || labelMap.dingdong.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}
              </Link>

            </li>
            : '')
        }
        {
          (user_profile.ARGameCount > 0 ?
            <li className={`info-menu custom-tooltip-wrapper`}>
              <Link onClick={() => { closeMenu(); redirectLobby("arcade") }} rel="noopener noreferrer nofollow">
                <div className="menu_icon">
                  {theme === 0 ? (
                    <img src={arcadeTopLight} className="header-icon promotion-icon" alt="Arcade" />
                  ) : (
                    <img src={arcadeTopDark} className="header-icon" alt="Arcade" />
                  )}
                </div>
                <p>{props.t("Arcade")}</p>
                {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("promo")) || labelMap.arcade.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
                {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("new")) || labelMap.arcade.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
                {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("hot")) || labelMap.arcade.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}
              </Link>

            </li>
            : '')
        }

        <li>
          <Link to={"/logout"} onClick={handleLogout} rel="noopener noreferrer nofollow">
            <div className="menu_icon">
              <FiLogOut className="header-icon" />
            </div>
            <p>{props.t("logout")}</p>
          </Link>
        </li>
      </ul >
    </div >
  );

  const handleBackClick = () => {
    setIsOpen(false);

    const menu = document.getElementById("menu");
    if (menu) {
      menu.scrollTop = 0;
    }

    // Add a delay before navigating
    setTimeout(() => {
      navigate("/promotion");
    }, 1000); // 1000ms = 1 second delay
  };


  const SettingsDropdown = () => (

    <div className="menu-dropdown">

      <div className="dropdown-content">
        <div onClick={handleShowCoachMark} className="tutorial-btn menu-dp-row">
          {theme === 0 ? (
            <img src={TutorialLight} className="header-icon result-icon" alt="Trophy" />
          ) : (
            <img src={TutorialDark} className="header-icon result-icon" alt="Trophy" />
          )}
          <h5 className="tuto-label">{props.t("Tutorial")}</h5>
        </div>


        <div className="promotion-btn menu-dp-row" onClick={handleBackClick}>
          {theme === 0 ? (
            <img src={PromotionLight} className="header-icon promotion-icon" alt="promotion" />
          ) : (
            <img src={PromotionDark} className="header-icon promotion-icon" alt="promotion" />
          )}
          <h5 className="promo-label">{props.t("Promotion")}</h5>
        </div>


        <div className="menu-dp-row" onClick={(e) => {
          e.stopPropagation(); // Prevent event bubbling to the Link
          toggleTheme();
        }}>
          <button
            className={`theme-toggle switch ${theme === 0 ? 'light' : 'dark'}`}
            onClick={(e) => {
              const newTheme = theme === 0 ? 1 : 0;
              setTheme(newTheme);
              e.stopPropagation(); // Prevent event bubbling to the Link
              toggleTheme();
            }}
            aria-label="Toggle theme"
          >
            <span className="slider">
              <div
                className={`icon sun-icon ${theme === 0 ? "active" : ""
                  }`}
              >
                <IoSunnyOutline className="header-icon" />
              </div>
              <div
                className={`icon moon-icon ${theme === 1 ? "active" : ""
                  }`}
              >
                <FaRegMoon className="header-icon" />
              </div>
            </span>
          </button>
          <p className="theme-label">
            {theme === 0 ? "Light" : "Dark"}
          </p>
        </div>

        <div className="menu-dp-row">
          <LanguageItemMobile />
        </div>


      </div>
      {showDropdown && <div className="dropdown-menu-overlay"></div>}
    </div>
  );
  const closeMenu = () => {
    setIsOpen(false);
    const menu = document.getElementById("menu");
    if (menu) {
      menu.scrollTop = 0;
    }
  };

  const [theme, setTheme] = useState(() => {
    const storedTheme = parseInt(localStorage.getItem("theme"));
    return isNaN(storedTheme) ? 0 : storedTheme;
  });
  const dTheme = theme === 0 ? 'light' : 'dark';

  useEffect(() => {
    document.body.setAttribute("data-theme", dTheme);
  }, [dTheme]);

  const toggleTheme = async () => {
    try {
      const response = await makeAjax(url.PLAYER_API.updateUserTheme, [], url.PLAYER_MS_EXT);
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      const newTheme = theme === 0 ? 1 : 0;
      localStorage.setItem("theme", newTheme);
      setTheme(newTheme);
      dispatch(getUserProfile());
    } catch (error) {
      console.error("Theme update failed:", error);
    }
  };

  return (
    <>
      {device === "Mobile" || device === "Tablet" ? (
        <div className={`navigation-mobile ${currentStep === 8 || currentStep === 9 || currentStep === 10
          ? "highlighted"
          : ""
          }`}>
          <HamburgerIcon />
        </div>
      ) : (
        <div className="header-right-menu">
          {/* <div
            className={`menu-item  setting-menu custom-tooltip-wrapper ${activeIcon === "info" ? "iconactive" : ""} ${currentStep === 8 ? "highlighted" : ""}`}
            // onMouseOver={() => setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
            onMouseOver={() => {
              if (currentStep !== 8) setShowDropdown(true); // Prevent dropdown if currentStep is 8
            }}
          >
            <img src={theme === "light" ? SettingIconLight : SettingIcon} className="header-icon  dream-img" />
            <h5>Settings</h5>
            {currentStep === 8 && <CoachMarkPopup />}
            {
              showDropdown && <SettingsDropdown />
            }

          </div> */}

          {currentStep === 8 && <div className="custom-overlay"></div>}

          <div
            className={`menu-item ${activeIcon === "info" ? "iconactive" : ""}`}
            onClick={() =>
              handlePopupOpen(<DreamBookPopup onClose={handleClosePopup} />, "dream")
            }
          >
            {/* <BsInfoCircle className="header-icon" /> */}
            <img src={theme === 0 ? DreamBookLight : DreamBook} className="header-icon  dream-img" />
            <h5>{props.t("dream_book")}</h5>
          </div>
          <div
            className={`menu-item result-menu custom-tooltip-wrapper ${activeIcon === "result" ? "iconactive" : ""
              } ${currentStep === 9 ? "highlighted" : ""}`}
            onClick={() => {
              navigate("/result");
              setActiveIcon("result");
            }}
          >
            {/* <BsTrophy className="header-icon" /> */}
            {
              theme === 0 ? (
                <img src={ResultImg} className="header-icon result-icon" alt="Trophy" />
              ) : (
                <img src={ResultDark} className="header-icon result-icon" alt="Trophy" />
              )
            }
            <h5>{props.t("result")}</h5>
            {currentStep === 9 && <CoachMarkPopup />}


          </div >
          {currentStep === 9 && <div className="custom-overlay"></div>}

          <div
            className={`menu-item info-menu custom-tooltip-wrapper ${activeIcon === "info" ? "iconactive" : ""} ${currentStep === 10 ? "highlighted" : ""}`}
            onClick={() =>
              handlePopupOpen(<InfoPopup onClose={handleClosePopup} />, "info")
            }
          >
            <BsInfoCircle className="header-icon" />
            <h5>Info</h5>
            {currentStep === 10 && <CoachMarkPopup />}

          </div>

          {currentStep === 10 && <div className="custom-overlay"></div>}

          <div
            className={`menu-item ${activeIcon === "notify" ? "iconactive" : ""
              }`}
            onClick={() =>
              handlePopupOpen(
                <NotificationPopup onClose={handleClosePopup} />,
                "notify"
              )
            }
          >
            <IoNotificationsOutline className="header-icon notiification" />
            <h5>Notify</h5>
            <div className="notify_count">{user_balance.countNotif}</div>
          </div>
          <div
            className={`menu-item  setting-menu custom-tooltip-wrapper ${activeIcon === "info" ? "iconactive" : ""} ${currentStep === 8 ? "highlighted" : ""}`}
            // onMouseOver={() => setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
            onMouseOver={() => {
              if (currentStep !== 8) setShowDropdown(true); // Prevent dropdown if currentStep is 8
            }}
          >
            <img src={theme === 0 ? SettingIconLight : SettingIcon} className="header-icon  dream-img" />
            <h5>Settings</h5>
            {currentStep === 8 && <CoachMarkPopup />}
            {
              showDropdown && <SettingsDropdown />
            }
          </div>

          {(user_profile.CGGameCount > 0 ?
            <div
              className={`menu-item custom-tooltip-wrapper`}
              onClick={() =>
                redirectLobby("cardgame")
              }
            >


              {theme === 0 ? (
                <img src={cardgameTopLight} className="header-icon promotion-icon" alt="Cardgame" />
              ) : (
                <img src={cardgameTopDark} className="header-icon" alt="Cardgame" />
              )}
              {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("promo")) || labelMap.cardgames.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
              {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("new")) || labelMap.cardgames.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
              {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("hot")) || labelMap.cardgames.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}

              <h5>Card Games</h5>

            </div>
            : '')}
          {(user_profile.DDGameCount > 0 ?
            <div
              className={`menu-item custom-tooltip-wrapper`}
              onClick={() =>
                redirectLobby("dingdong")
              }
            >
              {theme === 0 ? (
                <img src={dingdongTopLight} className="header-icon promotion-icon" alt="Dingdong" />
              ) : (
                <img src={dingdongTopDark} className="header-icon" alt="Dingdong" />
              )}

              {(labelMap.dingdong && ((labelMap.dingdong.includes("blink") && labelMap.dingdong.includes("promo")) || labelMap.dingdong.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
              {(labelMap.dingdong && ((labelMap.dingdong.includes("blink") && labelMap.dingdong.includes("new")) || labelMap.dingdong.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
              {(labelMap.dingdong && ((labelMap.dingdong.includes("blink") && labelMap.dingdong.includes("hot")) || labelMap.dingdong.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}

              <h5>Dingdong</h5>

            </div>
            : '')}
          {(user_profile.ARGameCount > 0 ?
            <div
              className={`menu-item custom-tooltip-wrapper`}
              onClick={() =>
                redirectLobby("arcade")
              }
            >
              {theme === 0 ? (
                <img src={arcadeTopLight} className="header-icon promotion-icon" alt="Arcade" />
              ) : (
                <img src={arcadeTopDark} className="header-icon" alt="Arcade" />
              )}

              {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("promo")) || labelMap.arcade.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
              {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("new")) || labelMap.arcade.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
              {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("hot")) || labelMap.arcade.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}

              <h5>Arcade</h5>

            </div>
            : '')}



          {/* <div
            className={`menu-item ${
              activeIcon === "statement" ? "iconactive" : ""
            }`}
            onClick={() =>
              handlePopupOpen(
                <StatementPopup onClose={handleClosePopup} />,
                "statement"
              )
            }
          >
            <TfiNotepad className="header-icon" />
            <h5>Statement</h5>
          </div>  */}

          <div
            className={`menu-item ${activeIcon === "logout" ? "iconactive" : ""
              }`}
            onClick={handleLogout}
          >
            <FiLogOut className="header-icon" />
            <h5>Logout</h5>
          </div>

          {
            popupComponent && (
              <div className="popup-overlay">{popupComponent}</div>
            )
          }
        </div >
      )}
    </>
  );
};

export default withTranslation()(HeaderRightMenu);
